module.exports = __webpack_public_path__ + "img/translationeditor_21.38dcc056.jpg";